/** Canonical MIME types allowed for expert-audio Storage + finalize (must stay in sync with bucket migration). */
const CANONICAL = new Set([
  "audio/webm",
  "audio/mp4",
  "audio/x-m4a",
  "audio/mpeg",
  "audio/wav",
  "audio/x-wav",
  "audio/wave",
]);

/** Strip parameters (e.g. codecs) and return a canonical type or null. */
export function normalizeExpertAudioMime(raw: string): string | null {
  const base = raw.split(";")[0].trim().toLowerCase();
  if (CANONICAL.has(base)) return base;
  return null;
}

/** File extension for Storage object key (must match allowed MIME). */
export function mimeToExpertUploadExtension(canonicalMime: string): string | null {
  switch (canonicalMime) {
    case "audio/webm":
      return "webm";
    case "audio/mp4":
    case "audio/x-m4a":
      return "m4a";
    case "audio/mpeg":
      return "mp3";
    case "audio/wav":
    case "audio/x-wav":
    case "audio/wave":
      return "wav";
    default:
      return null;
  }
}
